const VALIDATION_MESSAGES = {
  "gasInsertPreTestConditionsPrimary_yesOrNo1": "Please select just one option: yes or no (pre-test, primary, 1)",
  "gasInsertPreTestConditionsPrimary_yesOrNo2": "Please select just one option: yes or no (pre-test, primary, 2)",
  "gasInsertPreTestConditionsPrimary_yesOrNo3": "Please select just one option: yes or no (pre-test, primary, 3)",
  "gasInsertPreTestConditionsPrimary_yesOrNo4": "Please select just one option: yes or no (pre-test, primary, 4)",
  "gasInsertPreTestConditionsPrimary_yesOrNo5": "Please select just one option: yes or no (pre-test, primary, 5)",
  "gasInsertPreTestConditionsPrimary_yesOrNo6": "Please select just one option: yes or no (pre-test, primary, 6)",
  "gasInsertPreTestConditionsSecondary_yesOrNo1": "Please select just one option: yes or no (pre-test, Secondary, 1)",
  "gasInsertPreTestConditionsSecondary_yesOrNo2": "Please select just one option: yes or no (pre-test, Secondary, 2)",
  "gasInsertPreTestConditionsSecondary_yesOrNo3": "Please select just one option: yes or no (pre-test, Secondary, 3)",
  "gasInsertPreTestConditionsSecondary_yesOrNo4": "Please select just one option: yes or no (pre-test, Secondary, 4)",
  "gasInsertPreTestConditionsSecondary_yesOrNo5": "Please select just one option: yes or no (pre-test, Secondary, 5)",
  "gasInsertPreTestConditionsSecondary_yesOrNo6": "Please select just one option: yes or no (pre-test, Secondary, 6)",
  // 

  "gasInsertPostTestConditionsPrimary_yesOrNo1": "Please select just one option: yes or no (post-test, primary, 1)",
  "gasInsertPostTestConditionsPrimary_yesOrNo3": "Please select just one option: yes or no (post-test, primary, 3)",
  "gasInsertPostTestConditionsPrimary_yesOrNo4": "Please select just one option: yes or no (post-test, primary, 4)",
  "gasInsertPostTestConditionsPrimary_yesOrNo5": "Please select just one option: yes or no (post-test, primary, 5)",
  "gasInsertPostTestConditionsPrimary_yesOrNo6": "Please select just one option: yes or no (post-test, primary, 6)",
  "gasInsertPostTestConditionsSecondary_yesOrNo1": "Please select just one option: yes or no (post-test, Secondary, 1)",
  "gasInsertPostTestConditionsSecondary_yesOrNo3": "Please select just one option: yes or no (post-test, Secondary, 3)",
  "gasInsertPostTestConditionsSecondary_yesOrNo4": "Please select just one option: yes or no (post-test, Secondary, 4)",
  "gasInsertPostTestConditionsSecondary_yesOrNo5": "Please select just one option: yes or no (post-test, Secondary, 5)",
  "gasInsertPostTestConditionsSecondary_yesOrNo6": "Please select just one option: yes or no (post-test, Secondary, 6)",
  // 

  "gasInsertFlueOpenDoorPreTest_oneOption": "Please only select one option (pre-test, open door)",
  "gasInsertFlueClosedDoorPreTest_oneOption": "Please only select one option (pre-test, closed door)",
  "gasInsertFlueOpenDoorPostTest_oneOption": "Please only select one option (post-test, open door)",
  "gasInsertFlueClosedDoorPostTest_oneOption": "Please only select one option (post-test, closed door)",

  "preTestDraftAndSpillageOpenDoor_oneOption": "Please only select one option (pre-test, visual draft, open door)",
  "postTestDraftAndSpillageOpenDoor_oneOption": "Please only select one option (post-test, visual draft, open door)",

  //
  "freeStandingHeaterPreTestConditionsPrimary_yesOrNo1": "Please select just one option: yes or no (pre-test, primary, 1)",
  "freeStandingHeaterPreTestConditionsPrimary_yesOrNo2": "Please select just one option: yes or no (pre-test, primary, 2)",
  "freeStandingHeaterPreTestConditionsPrimary_yesOrNo3": "Please select just one option: yes or no (pre-test, primary, 3)",
  "freeStandingHeaterPreTestConditionsPrimary_yesOrNo4": "Please select just one option: yes or no (pre-test, primary, 4)",
  "freeStandingHeaterPreTestConditionsPrimary_yesOrNo5": "Please select just one option: yes or no (pre-test, primary, 5)",
  "freeStandingHeaterPreTestConditionsPrimary_yesOrNo6": "Please select just one option: yes or no (pre-test, primary, 6)",
  "freeStandingHeaterPreTestConditionsPrimary_yesOrNo7": "Please select just one option: yes or no (pre-test, primary, 7)",
  "freeStandingHeaterPreTestConditionsPrimary_yesOrNo8": "Please select just one option: yes or no (pre-test, primary, 8)",

  "freeStandingHeaterPreTestConditionsSecondary_yesOrNo1": "Please select just one option: yes or no (pre-test, secondary, 1)",
  "freeStandingHeaterPreTestConditionsSecondary_yesOrNo2": "Please select just one option: yes or no (pre-test, secondary, 2)",
  "freeStandingHeaterPreTestConditionsSecondary_yesOrNo3": "Please select just one option: yes or no (pre-test, secondary, 3)",
  "freeStandingHeaterPreTestConditionsSecondary_yesOrNo4": "Please select just one option: yes or no (pre-test, secondary, 4)",
  "freeStandingHeaterPreTestConditionsSecondary_yesOrNo5": "Please select just one option: yes or no (pre-test, secondary, 5)",
  "freeStandingHeaterPreTestConditionsSecondary_yesOrNo6": "Please select just one option: yes or no (pre-test, secondary, 6)",
  "freeStandingHeaterPreTestConditionsSecondary_yesOrNo7": "Please select just one option: yes or no (pre-test, secondary, 7)",
  "freeStandingHeaterPreTestConditionsSecondary_yesOrNo8": "Please select just one option: yes or no (pre-test, secondary, 8)",

  //

  "freeStandingHeaterPostTestConditionsPrimary_yesOrNo1": "Please select just one option: yes or no (post-test, primary, 1)",
  "freeStandingHeaterPostTestConditionsPrimary_yesOrNo2": "Please select just one option: yes or no (post-test, primary, 2)",
  "freeStandingHeaterPostTestConditionsPrimary_yesOrNo3": "Please select just one option: yes or no (post-test, primary, 3)",
  "freeStandingHeaterPostTestConditionsPrimary_yesOrNo5": "Please select just one option: yes or no (post-test, primary, 5)",
  "freeStandingHeaterPostTestConditionsPrimary_yesOrNo6": "Please select just one option: yes or no (post-test, primary, 6)",
  "freeStandingHeaterPostTestConditionsPrimary_yesOrNo7": "Please select just one option: yes or no (post-test, primary, 7)",
  "freeStandingHeaterPostTestConditionsPrimary_yesOrNo8": "Please select just one option: yes or no (post-test, primary, 8)",

  "freeStandingHeaterPostTestConditionsSecondary_yesOrNo1": "Please select just one option: yes or no (post-test, secondary, 1)",
  "freeStandingHeaterPostTestConditionsSecondary_yesOrNo2": "Please select just one option: yes or no (post-test, secondary, 2)",
  "freeStandingHeaterPostTestConditionsSecondary_yesOrNo3": "Please select just one option: yes or no (post-test, secondary, 3)",
  "freeStandingHeaterPostTestConditionsSecondary_yesOrNo5": "Please select just one option: yes or no (post-test, secondary, 5)",
  "freeStandingHeaterPostTestConditionsSecondary_yesOrNo6": "Please select just one option: yes or no (post-test, secondary, 6)",
  "freeStandingHeaterPostTestConditionsSecondary_yesOrNo7": "Please select just one option: yes or no (post-test, secondary, 7)",
  "freeStandingHeaterPostTestConditionsSecondary_yesOrNo8": "Please select just one option: yes or no (post-test, secondary, 8)",
} 

const useValidation = (control) => {
  const { getValues } = control;

  return {
    "gasInsertPreTestPrimaryConditions1_yes": () => ({ validate: () => {
        const yesOrNo = ["gasInsertPreTestPrimaryConditions1_yes", "gasInsertPreTestPrimaryConditions1_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPreTestConditionsPrimary_yesOrNo1'];
      },
    }),
    "gasInsertPreTestPrimaryConditions2_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPreTestPrimaryConditions2_yes", "gasInsertPreTestPrimaryConditions2_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPreTestConditionsPrimary_yesOrNo2'];
      },
    }),
    "gasInsertPreTestPrimaryConditions3_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPreTestPrimaryConditions3_yes", "gasInsertPreTestPrimaryConditions3_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPreTestConditionsPrimary_yesOrNo3'];
      },
    }),
    "gasInsertPreTestPrimaryConditions4_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPreTestPrimaryConditions4_yes", "gasInsertPreTestPrimaryConditions4_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPreTestConditionsPrimary_yesOrNo4'];
      },
    }),
    "gasInsertPreTestPrimaryConditions5_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPreTestPrimaryConditions5_yes", "gasInsertPreTestPrimaryConditions5_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPreTestConditionsPrimary_yesOrNo5'];
      },
    }),
    "gasInsertPreTestPrimaryConditions6_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPreTestPrimaryConditions6_yes", "gasInsertPreTestPrimaryConditions6_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPreTestConditionsPrimary_yesOrNo6'];
      },
    }),
    "gasInsertPreTestSecondaryConditions1_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPreTestSecondaryConditions1_yes", "gasInsertPreTestSecondaryConditions1_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPreTestConditionsSecondary_yesOrNo1'];
      },
    }),
    "gasInsertPreTestSecondaryConditions2_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPreTestSecondaryConditions2_yes", "gasInsertPreTestSecondaryConditions2_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPreTestConditionsSecondary_yesOrNo2'];
      },
    }),
    "gasInsertPreTestSecondaryConditions3_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPreTestSecondaryConditions3_yes", "gasInsertPreTestSecondaryConditions3_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPreTestConditionsSecondary_yesOrNo3'];
      },
    }),
    "gasInsertPreTestSecondaryConditions4_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPreTestSecondaryConditions4_yes", "gasInsertPreTestSecondaryConditions4_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPreTestConditionsSecondary_yesOrNo4'];
      },
    }),
    "gasInsertPreTestSecondaryConditions5_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPreTestSecondaryConditions5_yes", "gasInsertPreTestSecondaryConditions5_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPreTestConditionsSecondary_yesOrNo5'];
      },
    }),
    "gasInsertPreTestSecondaryConditions6_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPreTestSecondaryConditions6_yes", "gasInsertPreTestSecondaryConditions6_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPreTestConditionsSecondary_yesOrNo6'];
      },
    }),
    // 

    "gasInsertPostTestPrimaryConditions1_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPostTestPrimaryConditions1_yes", "gasInsertPostTestPrimaryConditions1_no", "gasInsertPostTestPrimaryConditions1_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPostTestConditionsPrimary_yesOrNo1'];
      },
    }),
    "gasInsertPostTestPrimaryConditions3_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPostTestPrimaryConditions3_yes", "gasInsertPostTestPrimaryConditions3_no", "gasInsertPostTestPrimaryConditions3_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPostTestConditionsPrimary_yesOrNo3'];
      },
    }),
    "gasInsertPostTestPrimaryConditions4_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPostTestPrimaryConditions4_yes", "gasInsertPostTestPrimaryConditions4_no", "gasInsertPostTestPrimaryConditions4_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPostTestConditionsPrimary_yesOrNo4'];
      },
    }),
    "gasInsertPostTestPrimaryConditions5_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPostTestPrimaryConditions5_yes", "gasInsertPostTestPrimaryConditions5_no", "gasInsertPostTestPrimaryConditions5_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPostTestConditionsPrimary_yesOrNo5'];
      },
    }),
    "gasInsertPostTestPrimaryConditions6_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPostTestPrimaryConditions6_yes", "gasInsertPostTestPrimaryConditions6_no", "gasInsertPostTestPrimaryConditions6_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPostTestConditionsPrimary_yesOrNo6'];
      },
    }),
    "gasInsertPostTestSecondaryConditions1_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPostTestSecondaryConditions1_yes", "gasInsertPostTestSecondaryConditions1_no", "gasInsertPostTestSecondaryConditions1_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPostTestConditionsSecondary_yesOrNo1'];
      },
    }),
    "gasInsertPostTestSecondaryConditions3_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPostTestSecondaryConditions3_yes", "gasInsertPostTestSecondaryConditions3_no", "gasInsertPostTestSecondaryConditions3_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPostTestConditionsSecondary_yesOrNo3'];
      },
    }),
    "gasInsertPostTestSecondaryConditions4_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPostTestSecondaryConditions4_yes", "gasInsertPostTestSecondaryConditions4_no", "gasInsertPostTestSecondaryConditions4_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPostTestConditionsSecondary_yesOrNo4'];
      },
    }),
    "gasInsertPostTestSecondaryConditions5_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPostTestSecondaryConditions5_yes", "gasInsertPostTestSecondaryConditions5_no", "gasInsertPostTestSecondaryConditions5_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPostTestConditionsSecondary_yesOrNo5'];
      },
    }),
    "gasInsertPostTestSecondaryConditions6_yes": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPostTestSecondaryConditions6_yes", "gasInsertPostTestSecondaryConditions6_no", "gasInsertPostTestSecondaryConditions6_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertPostTestConditionsSecondary_yesOrNo6'];
      },
    }),
    "gasInsertPreTestOpenDoor_nf": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPreTestOpenDoor_nf", "gasInsertPreTestOpenDoor_hazard", "gasInsertPreTestOpenDoor_fail"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertFlueOpenDoorPreTest_oneOption'];
      },
    }),
    "gasInsertPreTestClosedDoor_nf": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPreTestClosedDoor_nf", "gasInsertPreTestClosedDoor_hazard", "gasInsertPreTestClosedDoor_fail"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertFlueClosedDoorPreTest_oneOption'];
      },
    }),
    "gasInsertPostTestOpenDoor_nf": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPostTestOpenDoor_nf", "gasInsertPostTestOpenDoor_hazard", "gasInsertPostTestOpenDoor_fail"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertFlueOpenDoorPostTest_oneOption'];
      },
    }),
    "gasInsertPostTestClosedDoor_nf": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPostTestClosedDoor_nf", "gasInsertPostTestClosedDoor_hazard", "gasInsertPostTestClosedDoor_fail"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['gasInsertFlueClosedDoorPostTest_oneOption'];
      },
    }),
    "gasInsertPreTestVisualDraft_pass": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPreTestVisualDraft_pass", "gasInsertPreTestVisualDraft_fail", "gasInsertPreTestVisualDraft_hazard", "gasInsertPreTestVisualDraft_nf", "gasInsertPreTestVisualDraft_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['preTestDraftAndSpillageOpenDoor_oneOption'];
      },
    }),
    "gasInsertPostTestVisualDraft_pass": () => ({
      validate: () => {
        const yesOrNo = ["gasInsertPostTestVisualDraft_pass", "gasInsertPostTestVisualDraft_fail", "gasInsertPostTestVisualDraft_hazard", "gasInsertPostTestVisualDraft_nf", "gasInsertPostTestVisualDraft_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['postTestDraftAndSpillageOpenDoor_oneOption'];
      },
    }),

    // 


    "freeStandingHeaterPreTestPrimaryConditions1_yes": () => ({ validate: () => {
        const yesOrNo = ["freeStandingHeaterPreTestPrimaryConditions1_yes", "freeStandingHeaterPreTestPrimaryConditions1_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPreTestConditionsPrimary_yesOrNo1'];
      },
    }),
    "freeStandingHeaterPreTestPrimaryConditions2_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPreTestPrimaryConditions2_yes", "freeStandingHeaterPreTestPrimaryConditions2_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPreTestConditionsPrimary_yesOrNo2'];
      },
    }),
    "freeStandingHeaterPreTestPrimaryConditions3_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPreTestPrimaryConditions3_yes", "freeStandingHeaterPreTestPrimaryConditions3_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPreTestConditionsPrimary_yesOrNo3'];
      },
    }),
    "freeStandingHeaterPreTestPrimaryConditions4_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPreTestPrimaryConditions4_yes", "freeStandingHeaterPreTestPrimaryConditions4_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPreTestConditionsPrimary_yesOrNo4'];
      },
    }),
    "freeStandingHeaterPreTestPrimaryConditions5_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPreTestPrimaryConditions5_yes", "freeStandingHeaterPreTestPrimaryConditions5_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPreTestConditionsPrimary_yesOrNo5'];
      },
    }),
    "freeStandingHeaterPreTestPrimaryConditions6_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPreTestPrimaryConditions6_yes", "freeStandingHeaterPreTestPrimaryConditions6_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPreTestConditionsPrimary_yesOrNo6'];
      },
    }),
    "freeStandingHeaterPreTestPrimaryConditions7_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPreTestPrimaryConditions7_yes", "freeStandingHeaterPreTestPrimaryConditions7_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPreTestConditionsPrimary_yesOrNo7'];
      },
    }),
    "freeStandingHeaterPreTestPrimaryConditions8_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPreTestPrimaryConditions8_yes", "freeStandingHeaterPreTestPrimaryConditions8_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPreTestConditionsPrimary_yesOrNo8'];
      },
    }),
    "freeStandingHeaterPreTestSecondaryConditions1_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPreTestSecondaryConditions1_yes", "freeStandingHeaterPreTestSecondaryConditions1_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPreTestConditionsSecondary_yesOrNo1'];
      },
    }),
    "freeStandingHeaterPreTestSecondaryConditions2_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPreTestSecondaryConditions2_yes", "freeStandingHeaterPreTestSecondaryConditions2_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPreTestConditionsSecondary_yesOrNo2'];
      },
    }),
    "freeStandingHeaterPreTestSecondaryConditions3_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPreTestSecondaryConditions3_yes", "freeStandingHeaterPreTestSecondaryConditions3_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPreTestConditionsSecondary_yesOrNo3'];
      },
    }),
    "freeStandingHeaterPreTestSecondaryConditions4_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPreTestSecondaryConditions4_yes", "freeStandingHeaterPreTestSecondaryConditions4_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPreTestConditionsSecondary_yesOrNo4'];
      },
    }),
    "freeStandingHeaterPreTestSecondaryConditions5_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPreTestSecondaryConditions5_yes", "freeStandingHeaterPreTestSecondaryConditions5_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPreTestConditionsSecondary_yesOrNo5'];
      },
    }),
    "freeStandingHeaterPreTestSecondaryConditions6_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPreTestSecondaryConditions6_yes", "freeStandingHeaterPreTestSecondaryConditions6_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPreTestConditionsSecondary_yesOrNo6'];
      },
    }),
    "freeStandingHeaterPreTestSecondaryConditions7_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPreTestSecondaryConditions7_yes", "freeStandingHeaterPreTestSecondaryConditions7_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPreTestConditionsSecondary_yesOrNo7'];
      },
    }),
    "freeStandingHeaterPreTestSecondaryConditions8_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPreTestSecondaryConditions8_yes", "freeStandingHeaterPreTestSecondaryConditions8_no"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPreTestConditionsSecondary_yesOrNo8'];
      },
    }),

    //
    "freeStandingHeaterPostTestPrimaryConditions1_yes": () => ({ validate: () => {
        const yesOrNo = ["freeStandingHeaterPostTestPrimaryConditions1_yes", "freeStandingHeaterPostTestPrimaryConditions1_no", "freeStandingHeaterPostTestPrimaryConditions1_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPostTestConditionsPrimary_yesOrNo1'];
      },
    }),
    "freeStandingHeaterPostTestPrimaryConditions2_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPostTestPrimaryConditions2_yes", "freeStandingHeaterPostTestPrimaryConditions2_no", "freeStandingHeaterPostTestPrimaryConditions2_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPostTestConditionsPrimary_yesOrNo2'];
      },
    }),
    "freeStandingHeaterPostTestPrimaryConditions3_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPostTestPrimaryConditions3_yes", "freeStandingHeaterPostTestPrimaryConditions3_no", "freeStandingHeaterPostTestPrimaryConditions3_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPostTestConditionsPrimary_yesOrNo3'];
      },
    }),
    "freeStandingHeaterPostTestPrimaryConditions5_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPostTestPrimaryConditions5_yes", "freeStandingHeaterPostTestPrimaryConditions5_no", "freeStandingHeaterPostTestPrimaryConditions5_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPostTestConditionsPrimary_yesOrNo5'];
      },
    }),
    "freeStandingHeaterPostTestPrimaryConditions6_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPostTestPrimaryConditions6_yes", "freeStandingHeaterPostTestPrimaryConditions6_no", "freeStandingHeaterPostTestPrimaryConditions6_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPostTestConditionsPrimary_yesOrNo6'];
      },
    }),
    "freeStandingHeaterPostTestPrimaryConditions7_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPostTestPrimaryConditions7_yes", "freeStandingHeaterPostTestPrimaryConditions7_no", "freeStandingHeaterPostTestPrimaryConditions7_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPostTestConditionsPrimary_yesOrNo7'];
      },
    }),
    "freeStandingHeaterPostTestPrimaryConditions8_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPostTestPrimaryConditions8_yes", "freeStandingHeaterPostTestPrimaryConditions8_no", "freeStandingHeaterPostTestPrimaryConditions8_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPostTestConditionsPrimary_yesOrNo8'];
      },
    }),
    "freeStandingHeaterPostTestSecondaryConditions1_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPostTestSecondaryConditions1_yes", "freeStandingHeaterPostTestSecondaryConditions1_no", "freeStandingHeaterPostTestSecondaryConditions1_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPostTestConditionsSecondary_yesOrNo1'];
      },
    }),
    "freeStandingHeaterPostTestSecondaryConditions2_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPostTestSecondaryConditions2_yes", "freeStandingHeaterPostTestSecondaryConditions2_no", "freeStandingHeaterPostTestSecondaryConditions2_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPostTestConditionsSecondary_yesOrNo2'];
      },
    }),
    "freeStandingHeaterPostTestSecondaryConditions3_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPostTestSecondaryConditions3_yes", "freeStandingHeaterPostTestSecondaryConditions3_no", "freeStandingHeaterPostTestSecondaryConditions3_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPostTestConditionsSecondary_yesOrNo3'];
      },
    }),
    "freeStandingHeaterPostTestSecondaryConditions5_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPostTestSecondaryConditions5_yes", "freeStandingHeaterPostTestSecondaryConditions5_no", "freeStandingHeaterPostTestSecondaryConditions5_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPostTestConditionsSecondary_yesOrNo5'];
      },
    }),
    "freeStandingHeaterPostTestSecondaryConditions6_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPostTestSecondaryConditions6_yes", "freeStandingHeaterPostTestSecondaryConditions6_no", "freeStandingHeaterPostTestSecondaryConditions6_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPostTestConditionsSecondary_yesOrNo6'];
      },
    }),
    "freeStandingHeaterPostTestSecondaryConditions7_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPostTestSecondaryConditions7_yes", "freeStandingHeaterPostTestSecondaryConditions7_no", "freeStandingHeaterPostTestSecondaryConditions7_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPostTestConditionsSecondary_yesOrNo7'];
      },
    }),
    "freeStandingHeaterPostTestSecondaryConditions8_yes": () => ({
      validate: () => {
        const yesOrNo = ["freeStandingHeaterPostTestSecondaryConditions8_yes", "freeStandingHeaterPostTestSecondaryConditions8_no", "freeStandingHeaterPostTestSecondaryConditions1_na"];
        const count = yesOrNo.filter(answer => !!getValues(answer)).length;
        return (count === 1) || VALIDATION_MESSAGES['freeStandingHeaterPostTestConditionsSecondary_yesOrNo8'];
      },
    }),
  };
};

export default useValidation;
